var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"apply-msg msg-page"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }